import useStreamLakePlayer from '@/hooks/useStreamLakePlayer';
import { getVideoPlayToken } from '@/services/player';

interface IProps {
  videoId: string;
  [fileName: string]: any;
}

/**
 * 标准播放器
 * @returns
 */
const StandardizedWebPlayer = (props: IProps) => {
  const StreamLakePlayerReact = useStreamLakePlayer();
  return (
    <>
      {StreamLakePlayerReact && (
        <StreamLakePlayerReact
          {...props}
          plugins={{
            VideoIdPlugin: {
              getPlayToken: getVideoPlayToken,
            },
          }}
        />
      )}
    </>
  );
};

export default StandardizedWebPlayer;
